<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-5">
                  <CIcon size="sm" name="cil-building" />Cursos Asignados
                </div>
                <div class="col-12 col-xl-7">
                  <div class="row">
                    <div class="col-12 col-xl-3"></div>
                    <div class="col-12 col-xl-5">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-4">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >
                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen cursos asignados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #type_of_course-filter>
                <v-select
                  :options="typeOfCourseOptions"
                  label="name"
                  :reduce="(typeOfCourse) => typeOfCourse.value"
                  v-model="columnFilter.type_of_course"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #syllabus_description-filter>
                <v-select
                  :options="syllabusOptions"
                  label="description"
                  :reduce="(syllabus) => syllabus.id"
                  v-model="columnFilter.syllabus_id"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>

              <template #course_name="{ item }">
                <td>
                  <span>{{ item.course_name }}</span
                  ><br />
                  <span>Paralelo: {{ item.parallel }}</span> &nbsp;
                  <span>Aula: {{ item.classroom }}</span>
                </td>
              </template>

              <template #time="{ item }">
                <td>
                  <span style="white-space: pre">{{
                    item | time_courses_offered
                  }}</span>
                </td>
              </template>
              <template #period="{ item }">
                <td>
                  <span>{{
                    `${item.period}/${item.courses_offered_year}`
                  }}</span>
                </td>
              </template>

              <template #type_of_course="{ item }">
                <td>{{ item.type_of_course | type_of_course }}</td>
              </template>

              <template #syllabus_description="{ item }">
                <td>
                  {{
                    item.syllabus_description + " v." + item.syllabus_version
                  }}
                </td>
              </template>

              <template #enabled="{ item }">
                <td>
                  <CBadge color="success" v-if="item.enabled == true"
                    >Activo</CBadge
                  >
                  <CBadge color="danger" v-else>Inactivo</CBadge>
                </td>
              </template>

              <template #detail="{ item }">
                <td>
                  <b-button-group size="xs">
                    <!-- ver estudiantes -->
                    <b-button
                      @click="modalRegisteredStudentList(item.id)"
                      variant="primary"
                      :title="'Ver estudiantes'"
                    >
                      <CIcon size="sm" name="cil-people" />
                    </b-button>
                    <!-- descargar archivo de calificaciones -->
                    <b-button
                      @click="exportGrades(item.id)"
                      variant="info"
                      :title="'Descargar archivo de calificaciones'"
                    >
                      <CIcon size="sm" name="cil-cloud-download" />
                    </b-button>
                    <!-- subir archivo de calificaciones -->
                    <b-button
                      :to="{ path: 'calificaciones/importar/' + item.id }"
                      variant="warning"
                      :title="'Subir archivo de calificaciones'"
                      v-auth-roles="{
                        user: userAuth,
                        roles: [const_roles.ROLE_TEACHER],
                      }"
                    >
                      <CIcon size="sm" name="cil-cloud-upload" />
                    </b-button>
                  </b-button-group>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
    <section v-if="modShowRegisteredStudentList">
      <RegisteredStudentsListModal
        :course_offered_id="course_offered_id"
        :modShowRegisteredStudentList="modShowRegisteredStudentList"
        @registeredStudentsListModal="afterRegisteredStudentList"
      ></RegisteredStudentsListModal>
    </section>
  </section>
</template>
<script>
import {
  BAlert,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesOffered from "@/plugins/services/courses-offered";
import Syllabus from "@/plugins/services/syllabus";
// components
import RegisteredStudentsListModal from "@/entities/registrations/RegisteredStudentsListModal.vue";
import GradesImport from "@/entities/grades/GradesImport.vue";

export default {
  name: "CoursesOfferedTeacherList",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    RegisteredStudentsListModal,
    GradesImport,
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "course_name",
          label: "Curso",
          sorter: false,
          _style: "min-width: 160px;",
        },
        {
          key: "time",
          label: "Horario",
          sorter: false,
          filter: false,
          _style: "width: 15%;",
        },
        {
          key: "period",
          label: "Periodo",
          sorter: false,
          filter: false,
          _style: "width: 7%;",
        },
        {
          key: "syllabus_description",
          label: "Plan de estudio",
          _style: "min-width: 100px;",
        },
        {
          key: "type_of_course",
          label: "Tipo de curso",
          _style: "width: 15%;",
          sorter: false,
        },
        {
          key: "enabled",
          label: "Estado",
          filter: true,
          sorter: false,
          _style: "width: 10%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 130px;",
        },
      ],
      items: [],
      teacher: null,
      columnFilter: { column: "created_at", asc: false, enabled: true },
      coursesOfferedYearsOptions: [],
      const_roles: Constants.roles,
      periodOptions: Constants.periodOptions,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      enabledOptions: Constants.enabledOptions,
      syllabusOptions: [],
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      course_offered_id: 0,
      id_teacher: 0,
      modShowRegisteredStudentList: false,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.columnFilter.person_id = this.userAuth.person_id;
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
    this.getSyllabus();
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("courses-offered-teacher", q);
      CoursesOffered.alltwo(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: "created_at",
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        person_id: this.userAuth.person_id,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAll()
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modalRegisteredStudentList(id) {
      this.modShowRegisteredStudentList = true;
      this.course_offered_id = id;
    },
    afterRegisteredStudentList(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowRegisteredStudentList = response.modalShow;
    },
    exportGrades(id) {
      var url = `${process.env.MIX_APP_API_ENDPOINT}/grades/export/${id}`;
      var win = window.open(url, "_blank");
      win.focus();
    },
  },
};
</script>
